module.exports = __webpack_public_path__ + "img/faile_icon2.4da9aa9e.png";